import React from "react";
import "./PlainButton.css";

interface PlainButtonProps {
  text: React.ReactNode; // <-- change from string to React.ReactNode
  onClick?: () => void;
  disabled?: boolean;
  bgColor?: string; // optional background color
  textColor?: string; // optional text color
}

const PlainButton: React.FC<PlainButtonProps> = ({
  text,
  onClick,
  disabled = false,
  bgColor,
  textColor,
}) => {
  const style: React.CSSProperties = {};
  if (bgColor) {
    style.backgroundImage = bgColor.startsWith("linear") ? bgColor : undefined;
    style.background = !bgColor.startsWith("linear") ? bgColor : undefined;
  }
  if (textColor) style.color = textColor;

  return (
    <button
      className={`plain-button ${disabled ? "plain-button--disabled" : ""}`}
      onClick={onClick}
      disabled={disabled}
      style={style}
    >
      {text}
    </button>
  );
};

export default PlainButton;
